import { render, staticRenderFns } from "./DocumentCloudHolder.vue?vue&type=template&id=2672c62a&scoped=true&"
import script from "./DocumentCloudHolder.vue?vue&type=script&lang=js&"
export * from "./DocumentCloudHolder.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCloudHolder.vue?vue&type=style&index=0&id=2672c62a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672c62a",
  null
  
)

export default component.exports